import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { DataProvider } from "@/context/DataContext";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Demandes from "@/pages/Demandes";
import DemandeDetail from "@/pages/DemandeDetail";
import Agenda from "@/pages/Agenda";
import Missions from "@/pages/Missions";
import Clients from "@/pages/Clients";
import Reglages from "@/pages/Reglages";

function App() {
  return (
    <DataProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="demandes" element={<Demandes />} />
            <Route path="demandes/:id" element={<DemandeDetail />} />
            <Route path="agenda" element={<Agenda />} />
            <Route path="missions" element={<Missions />} />
            <Route path="clients" element={<Clients />} />
            <Route path="reglages" element={<Reglages />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </DataProvider>
  );
}

export default App;
